import React, { useEffect, useState } from "react";
import "./style.scss";
import SocialShare from "../../../general/socials";
import Podcastdetail from "./Podcastdetail";
import { getKnowledgeStackPodcast } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

const Podcasts = (props) => {
  const {
    getKnowledgeStackPodcast,
    knowledgepodcastlist,
    location: { pathname },
  } = props;

  const current = pathname.split("/")[3];
  const currentDetail = pathname.split("/")[4] ? pathname.split("/")[4] : "";
  const [podcastList, setPodcastList] = useState();
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const [metaData, setMetaData] = useState();

  const handleClick = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
    setShare(true);
  };

  const addTodo = () => {
    setShare(false);
  };

  useEffect(() => {
    getKnowledgeStackPodcast();
  }, []);

  useEffect(() => {
    if (
      knowledgepodcastlist &&
      knowledgepodcastlist.podcastData &&
      knowledgepodcastlist.podcastData.podcast
    ) {
      setPodcastList(knowledgepodcastlist.podcastData.podcast);
    }

    if (
      knowledgepodcastlist &&
      knowledgepodcastlist.podcastData &&
      knowledgepodcastlist.podcastData.meta
    ) {
      setMetaData(knowledgepodcastlist.podcastData.meta);
    }
  }, [knowledgepodcastlist]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <>
      {currentDetail === "" || currentDetail === undefined ? (
        <div className="wrapper">
          {metaData ? (
            <Helmet>
              <title>{metaData && metaData.title ? metaData.title : ""}</title>
              <meta
                name="description"
                content={
                  metaData && metaData.description ? metaData.description : ""
                }
              />
              <meta
                name="keywords"
                content={metaData && metaData.keywords ? metaData.keywords : ""}
              />
              <meta
                property="og:title"
                content={metaData && metaData.og_title ? metaData.og_title : ""}
              />
              <meta
                property="og:description"
                content={
                  metaData && metaData.og_description
                    ? metaData.og_description
                    : ""
                }
              />
              <meta
                property="og:image"
                content={metaData && metaData.og_image ? metaData.og_image : ""}
              />
              <meta
                property="og:url"
                content={metaData && metaData.og_url ? metaData.og_url : ""}
              />
            </Helmet>
          ) : (
            ""
          )}
          <section className="aboutHead">
            <div className="container">
              <div className="d-flex">
                <h1 className="me-auto">
                  <span>Podcast</span>
                </h1>
                <nav
                  aria-label="breadcrumb"
                  className="align-self-center breadCrumbCust d-md-inlin"
                >
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="/knowledge-stack">Knowledge Stack</a>
                    </li>
                    <li
                      className="breadcrumb-item active breadcolor"
                      aria-current="page"
                    >
                      Podcast
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </section>

          <section>
            <div className="container mt-5 mb-5">
              <div className="bluediv">
                <div className="reddiv">
                  <div className="podcastdiv">
                    <h2>Podcast Series</h2>
                  </div>
                </div>
              </div>

              <div className="seriesp">
                <h2 className="mt-5 mb-3">Podcast Series</h2>

                <div className="row">
                  {podcastList &&
                    podcastList.length > 0 &&
                    podcastList.map((item, index) => (
                      <div className="col-lg-6 mb-3">
                        <div className="podcastcard p-4">
                          <div className="row">
                            <div className="col-md-4">
                              <img
                                src={
                                  item.thumbnail && item.thumbnail.url
                                    ? item.thumbnail.url
                                    : ""
                                }
                                alt={
                                  item.thumbnail && item.thumbnail.alt
                                    ? item.thumbnail.alt
                                    : ""
                                }
                                className="seriesimg"
                              />
                            </div>
                            <div className="col-md-8 mt-md-0 mt-4">
                              <div>
                                <a
                                  href={`/knowledge-stack/interactive-media/podcast/${item.linkUrl}`}
                                >
                                  <h3 className="podtitle mb-2">
                                    {item.title ? item.title : ""}
                                  </h3>
                                </a>
                                <p>{item.summary ? item.summary : ""}</p>
                                <div className="my-3 d-flex">
                                  <p className="duration">
                                    Duration :{" "}
                                    <span>
                                      {item.duration ? item.duration : ""}
                                    </span>
                                  </p>
                                  <p className="duration ms-4">
                                    Episodes :{" "}
                                    <span>
                                      {item.total_episodes
                                        ? item.total_episodes
                                        : ""}
                                    </span>
                                  </p>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                  <a
                                    href={`/knowledge-stack/interactive-media/podcasts/${item.linkUrl}`}
                                  >
                                    <div className="btn btn-rpimary d-flex justify-content-center align-items-center">
                                      <img
                                        src="/images/New/KnowledgeStack/podcastplay.svg"
                                        alt="play"
                                      />
                                      <p className="ms-2">Listen Now</p>
                                    </div>
                                  </a>
                                  <div className="share">
                                    <div
                                      className="sharediv"
                                      onClick={() => handleClick(index)}
                                    >
                                      <img
                                        src="/images/New/KnowledgeStack/shareicon.svg"
                                        alt="share"
                                        className="p-2"
                                      />
                                      {share && cardId === index && (
                                        <SocialShare
                                          sharebtn="message"
                                          addTodo={addTodo}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <Podcastdetail
          suggestedUrl={currentDetail}
          typeData={current}
          overviewTab={knowledgepodcastlist}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  knowledgepodcastlist: state.KnowledgeStack,
});

const mapDispatchToProps = (dispatch) => ({
  getKnowledgeStackPodcast: bindActionCreators(
    getKnowledgeStackPodcast,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Podcasts);
